_ = require 'underscore'

module.exports = new class
  constructor: ->
    @holding = false
    @fxs = {}
    @_unnamed = 0
    @_dequeued = {}

  hold: ->
    @holding = true

  enqueue: ([name]..., fx) ->
    name ?= "unnamed_#{ @_unnamed++ }"

    if @holding
      @fxs[name] = fx
    else
      fx({ immediate: true, delayed: false })
    return

  dequeue: (name) ->
    @_dequeued[name] = true
    delete @fxs[name]

  release: ->
    @holding = false

    fxToRun = @fxs
    @fxs = {}

    _.defer =>
      # It's possible that a deferred action might dequeue another
      # deferred action, so we have to check to make sure each entry is still
      # queued
      for name, fx of fxToRun when !@_dequeued[name]
        fx({ immediate: false, delayed: true })

      @_dequeued = {}
      return

    return



// WEBPACK FOOTER //
// ./app/scripts/views/lib/post-render.coffee